/* tslint:disable */
/* eslint-disable */
/**
 * KNMI exons API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { StaticMapOverlay } from '../types';
/**
 * StaticMapOverlaysApi - axios parameter creator
 * @export
 */
export const StaticMapOverlaysApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns all StaticMapOverlays
         * @summary List all StaticMapOverlays
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStaticMapOverlays: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/static_map_overlays`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StaticMapOverlaysApi - functional programming interface
 * @export
 */
export const StaticMapOverlaysApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StaticMapOverlaysApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns all StaticMapOverlays
         * @summary List all StaticMapOverlays
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStaticMapOverlays(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StaticMapOverlay>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStaticMapOverlays(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StaticMapOverlaysApi.getStaticMapOverlays']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * StaticMapOverlaysApi - factory interface
 * @export
 */
export const StaticMapOverlaysApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StaticMapOverlaysApiFp(configuration)
    return {
        /**
         * Returns all StaticMapOverlays
         * @summary List all StaticMapOverlays
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStaticMapOverlays(options?: RawAxiosRequestConfig): AxiosPromise<Array<StaticMapOverlay>> {
            return localVarFp.getStaticMapOverlays(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StaticMapOverlaysApi - object-oriented interface
 * @export
 * @class StaticMapOverlaysApi
 * @extends {BaseAPI}
 */
export class StaticMapOverlaysApi extends BaseAPI {
    /**
     * Returns all StaticMapOverlays
     * @summary List all StaticMapOverlays
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StaticMapOverlaysApi
     */
    public getStaticMapOverlays(options?: RawAxiosRequestConfig) {
        return StaticMapOverlaysApiFp(this.configuration).getStaticMapOverlays(options).then((request) => request(this.axios, this.basePath));
    }
}

